export const isEmptyOrUndefined = (value: string): boolean => {
  return value ? true : false;
};

export const extractNonZeroPositiveNumber = (value: string): string => {
  const numbersReg = /[1-9][0-9]*/g;
  // Extract the numbers that don't start with 0. (May remove 0s when pasting incorrect numbers eg. 34ff04ff -> [34,4])
  // Join the numbers back together
  return value.match(numbersReg)?.join("") || "";
};

/**
 * @deprecated  Use formatNumber instead!
 */
export const numberCommaDecimal = (value: number): string => {
  return value.toLocaleString("de", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Function to convert a number to follow the  dot for thousand separator and comma for fraction separator convention.
 * @param value The number to format
 * @param format The formatting preference: fraction to always show a 2 digit fraction, thousand to always show the thousand separator
 * @returns A string of the formatted number with dot for thousand separator and comma for fraction separator.
 */
export const formatNumber = (
  value: number,
  format: "fraction" | "thousand" = "thousand"
): string => {
  const minimumFractionDigits = format === "fraction" ? 2 : undefined;
  const maximumFractionDigits = format === "fraction" ? 2 : undefined;
  return value.toLocaleString("de", {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  });
};
